import script from "./DocumentLibrary.vue?vue&type=script&setup=true&lang=ts"
export * from "./DocumentLibrary.vue?vue&type=script&setup=true&lang=ts"

import "./DocumentLibrary.vue?vue&type=style&index=0&id=2b341362&lang=scss"

const __exports__ = script;

export default __exports__